import {Column} from '../Column';
import {priority} from '@priority-software/priority-proto-api/lib';
import {Form} from '../Form';

export const prepareColumnsMap = (
    form: Form,
    columns: priority.netitems.form.IColumn[] = [],
    tableColumnsDesign: priority.netitems.form.ITableViewColumnsDesign[] = []
) => {
    const columnsMap = new Map<number, Column>();
    let fixedColumnsNumber = 1;
    let visibleIndex = 0;

    if (tableColumnsDesign.length > 0) {
        const apiHiddenColumns = columns.filter(c => c.Hidden);

        tableColumnsDesign.forEach(columnDesign => {
            const colData = columns?.find(c => c.Name === columnDesign.Name);

            if (colData) {
                const colInstance = new Column(form, {
                    ...colData,
                    Title: columnDesign.Title || colData.Title,
                    Hidden: !!columnDesign.Hidden || colData.Hidden
                });
                if (!colInstance.hidden) {
                    colInstance.setColumnIndex(visibleIndex);
                    if (columnDesign.Cover) {
                        // Fixed columns count
                        fixedColumnsNumber = visibleIndex + 1;
                    }
                    visibleIndex++;
                }
                columnsMap.set(colInstance.id, colInstance);
            }
        });

        apiHiddenColumns.forEach(hiddenColumn => {
            const colInstance = new Column(form, hiddenColumn);
            columnsMap.set(colInstance.id, colInstance);
        });
    } else {
        columns.forEach(column => {
            const colInstance = new Column(form, column);
            if (!colInstance.hidden) {
                colInstance.setColumnIndex(visibleIndex);
                visibleIndex++;
            }
            columnsMap.set(colInstance.id, colInstance);
        });
    }

    return {columnsMap, fixedColumnsNumber};
};
